module.exports = __webpack_public_path__ + "img/1-6.0d05cc97.png";